import { ReadingSession } from "./types";
import "./App.css";

export const ReadingSessionContainer = ({
  readingSession,
}: {
  readingSession: ReadingSession;
}) => {
  return (
    <div className="sessionRow">
      <div className="pagesContainer">
        <span className="pages">
          +{readingSession.page_finish - readingSession.page_start}
        </span>
        <span className="pags">pages</span>
      </div>
      <div className="sessionInfoContainer">
        <div> {new Date(readingSession.date).toLocaleDateString()}</div>
        <div>
          from {readingSession.page_start} to {readingSession.page_finish}
        </div>
      </div>
    </div>
  );
};
